import React from 'react'
import IMGS from '../assets'

import '../styles/investments.css'
import { FcPhoneAndroid } from "react-icons/fc";
import { GrMapLocation } from "react-icons/gr";

const Investment = () => {
  return (
    <>
      <div className="investments">
        <div className="inv-header">
          <h4 style={{ "backgroundImage": `url(${IMGS.ws})` }}>.</h4>
          <p className="lft">Discover investment opportunities that match your goals</p>
          <p className="ryt">Whether you are investing for your future, preparing for retirement or looking to invest sustainably,
            Flagstar Wealth Management offers a wide range of investments so you can decide what fits your needs. As listed below
          </p>
          <ul>
            <li>Investment accounts</li>
            <li>Investment products</li>
            <li>Estate and Trust planning</li>
            <li>Annuity & Insurance</li>
            <li>Lending products</li>
          </ul>
        </div>
        <div className="inv-opts">
          <div className="inv-opt">
            <h3>Investment accounts</h3>
            <ul>
              <li>
                <h4>IRA</h4>
                <p>Available at any career stage, an IRA is for individuals with taxable compensation who are planning for retirement.
                </p>
              </li>
              <li>
                <h4>Traditional IRA</h4>
                <p>A Traditional IRA is an individual retirement account that allows potentially tax-deductible contributions and tax-deferred earnings,
                  if any, that can help you save for your retirement.
                </p>
              </li>
              <li>
                <h4>Roth IRA</h4>
                <p>A Roth IRA is an individual retirement account to which you contribute after-tax dollars.
                  While there are no deductions for contributions, your earnings, if any, are tax-deferred and may be tax-free upon withdrawal if certain conditions are met.
                </p>
              </li>
              <li>
                <h4>Brokerage</h4>
                <p>Invest in thousands of investments including stocks, ETFs, mutual funds and options.</p>
              </li>
              <li>
                <h4>529 college savings plan</h4>
                <p>Invest in future education goals for you or your loved ones.</p>
              </li>
            </ul>
          </div>
          <div className="inv-opt">
            <h3>Investment products</h3>
            <ul>
              <li>
                <h4>Stocks</h4>
                <p>Invest in publicly traded companies and start customizing your investment portfolio today.</p>
              </li>
              <li>
                <h4>Options</h4>
                <p>Potentially generate income and hedge your portfolio with options, a flexible tool that can help you invest in any market direction.</p>
              </li>
              <li>
                <h4>Mutual funds</h4>
                <p>A professionally managed portfolio of securities such as stocks, bonds and other assets.</p>
              </li>
              <li>
                <h4>Fixed income</h4>
                <p>From bonds to CDs, fixed income investments can help add steady earnings to your portfolio.</p>
              </li>
              <li>
                <h4>Brokered CDs</h4>
                <p>Get a set rate of interest over a fixed time period and predictable returns with brokered CDs.</p>
              </li>
              <li>
                <h4>Sustainable investing</h4>
                <p>Invest based on what matters to you most through sustainable investing.</p>
              </li>
              <li>
                <h4>Sector investing</h4>
                <p>Gain exposure to specific market sectors including energy, financials, healthcare and more.</p>
              </li>
              <li>
                <h4>ETFs</h4>
                <p>Structured like mutual funds but traded like stocks, exchange-traded funds (ETFs) can provide market flexibility.</p>
              </li>
              <li>
                <h4>Crypto Currency ETFs</h4>
                <p>Explore funds that track the performance of at least one cryptocurrency or invest in related technologies.</p>
              </li>
              <li>
                <h4>Index ETFs</h4>
                <p>Like regular ETFs, index ETFs offer exposure to a diverse range of investments and sectors, and typically have lower expense ratios than mutual funds.</p>
              </li>
            </ul>
          </div>
          <div className="inv-opt">
            <h3>Estate and Trust planning</h3>
            <ul>
              <li>
                <h4>Estate planning</h4>
                <p>Direct the transfer of your assets in a tax-efficient way to your designated beneficiaries and appoint trusted decision-makers to reduce the possibility of legal intervention upon your death or incapacitation.</p>
              </li>
              <li>
                <h4>Trusts</h4>
                <p>A trust is an estate planning tool that helps you control the distribution of your assets.</p>
              </li>
              <li>
                <h4>Donor-advised funds</h4>
                <p>Flagstar Wealth Management lets you determine how your charitable donations are invested so you can give to the causes you care about most.</p>
              </li>
            </ul>
          </div>
          <div className="inv-opt">
            <h3>Annuity & Insurance</h3>
            <ul>
              <li>
                <h4>Annuities</h4>
                <p>Check in on your investments with a Flagstar Private Client Advisor to choose the right annuity for you and retire with more confidence.</p>
              </li>
              <li>
                <h4>Life insurance</h4>
                <p>Extend the benefits of life insurance to your family so you can worry less about the future.</p>
              </li>
              <li>
                <h4>Annuity MAC</h4>
                <p>The Flagstar Multi-Asset Choice® annuity provides the benefit of tax-deferred investments with professional guidance, long-term flexibility and liquidity when you need it.</p>
              </li>
            </ul>
          </div>
          <div className="inv-opt">
            <h3>Lending products</h3>
            <ul>
              <li>
                <h4>Securities-based lending</h4>
                <p>Get access to a line of credit backed by non-retirement, marketable securities such as stocks, bonds and mutual funds.</p>
              </li>
              <li>
                <h4>Margin trading</h4>
                <p>Margin allows you to borrow against the securities in your account to purchase additional securities.</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="get-started">
          <h2>Ready to get started?</h2>
          <p>Whether you're a first-time investor or already have a portfolio and need a trained eye to review it and make recommendations, our Financial Consultants are ready to help.</p>
          <ul>
            <li>
              <FcPhoneAndroid />
              <h5>Contact Us</h5>
              <p>Let us know your needs via live chat, and one of our Financial Consultants will get in touch.</p>
            </li>
            <li>
              <GrMapLocation />
              <h5>Find our Financial Consultants</h5>
              <p>Locate one of our Financial Consultants in your area.</p>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Investment